<template>
  <div
    class="section-btn rb shadow bold"
    :class="
      disabled || loading
        ? subtitle
          ? 'subtitle-padding disabled'
          : 'disabled'
        : !loading && active === btn
        ? 'active'
        : 'zoom'
    "
    @click="handleClick"
  >
    {{ name }}
    <div class="subtitle" v-if="subtitle">
      {{ subtitle }}
    </div>
    <div class="subtitle" v-if="loading">
      Loading data...
    </div>
  </div>
</template>

<script>
export default {
  name: "sectionButton",
  props: {
    name: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
      type: Number,
      default: 0
    },
    btn: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleClick() {
      this.$emit("buttonClicked", this.btn);
    }
  }
};
</script>
